import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from '~/router'
import { ErrorBoundary } from '~/components/shared/error-boundary'
import { useAuthStore } from '~/stores/auth-store'

/** 앱 루트. 라우터 + 최상위 에러 경계를 제공한다. */
export function App() {
    const checkSession = useAuthStore((s) => s.checkSession)

    // 앱 로드(및 knoka 콜백 후 앱 루트 복귀) 시 세션 쿠키로 로그인 상태를 확인한다.
    useEffect(() => {
        void checkSession()
    }, [checkSession])

    return (
        <ErrorBoundary>
            <RouterProvider router={router} />
        </ErrorBoundary>
    )
}
